var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "information-banner", class: _vm.classes }, [
    _vm.illustrationPosition === "left"
      ? _c("div", { staticClass: "information-banner__illustration" }, [
          _c("img", { attrs: { src: _vm.sourceIllustration } })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "information-banner__content" },
      [
        _c("h2", { staticClass: "typographies-heading-h2" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
        ]),
        _vm._v(" "),
        _vm.showDescription
          ? _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
              _vm._v("\n            " + _vm._s(_vm.description) + "\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("description")
      ],
      2
    ),
    _vm._v(" "),
    _vm.illustrationPosition !== "left"
      ? _c("div", { staticClass: "information-banner__illustration" }, [
          _c("img", { attrs: { src: _vm.sourceIllustration } })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }